import Model from "../model";
import request from "../../request/request";

const EnumReportVersion = {
  EnumReportVersionDefault: 0, // 普通版(旧版)
  EnumReportVersionPL: 1, // 陪练版本(旧版-已废弃)
  EnumReportVersionConfigGroup40: 40 // 配置组报告页V4.0(新版)
};
const EnumShowType = {
  EnumShowTypeDimension: 0, // 维度
  EnumShowTypeDimensionGroup: 1 // 维度组
};
const EnumScoreType = {
  EnumScoreTypeQuestion: 0, // 题目计分法
  EnumScoreTypeInterview: 1 // 面试计分法
};
const EnumSuggestType = {
  EnumSuggestTypeClose: 0, // 关闭
  EnumSuggestTypeCommon: 1, // 通用
  EnumSuggestTypePL: 2 // 陪练
};
const EnumBoolOption = {
  EnumBoolOptionUndefined: 0, // 创建修改:未定义、默认 使用判断:关、否
  EnumBoolOptionOn: 1, // 开、是
  EnumBoolOptionOff: 2, // 关、否
  EnumBoolOptionIgnore: 255 // 应该忽略
};
// 报告页展示配置
export class StructReportShowConfig extends Model {
  hiddenTotalScore = EnumBoolOption.EnumBoolOptionUndefined; // 是否隐藏总分数
  hiddenCandidateIndex = EnumBoolOption.EnumBoolOptionUndefined; // 是否隐藏候选人同职位竞争力排序
  hiddenOverview = EnumBoolOption.EnumBoolOptionUndefined; // 是否隐藏AI面试总览
  hiddenOverviewPieChart = EnumBoolOption.EnumBoolOptionUndefined; // 是否隐藏AI面试总览-饼状图
  hiddenOverviewDimensionGroupIcon = EnumBoolOption.EnumBoolOptionUndefined; // 是否隐藏AI面试总览-维度组ICON
  hiddenOverviewAiComment = EnumBoolOption.EnumBoolOptionUndefined; // 是否隐藏AI面试总览-AI评价
  hiddenOverviewHrComment = EnumBoolOption.EnumBoolOptionUndefined; // 是否隐藏AI面试总览-HR评价
  hiddenOverviewNextSuggest = EnumBoolOption.EnumBoolOptionUndefined; // 是否隐藏AI面试总览-下一轮面试建议
  hiddenPsyc = EnumBoolOption.EnumBoolOptionUndefined; // 是否隐藏心理测评
  hiddenDimensionAnalyze = EnumBoolOption.EnumBoolOptionUndefined; // 是否隐藏维度分析
  hiddenCandidateAnswer = EnumBoolOption.EnumBoolOptionUndefined; // 是否隐藏回答记录
  hiddenCandidateAnswerAiComment = EnumBoolOption.EnumBoolOptionUndefined; // 是否隐藏回答记录中的AI评价
  hiddenErrorInfo = EnumBoolOption.EnumBoolOptionUndefined; // 是否隐藏异常信息
  hiddenOtherInfo = EnumBoolOption.EnumBoolOptionUndefined; // 是否隐藏其他信息
  hiddenDimensionChart = EnumBoolOption.EnumBoolOptionUndefined; // 是否隐藏非维度组图表
  hiddenDimensionComport = EnumBoolOption.EnumBoolOptionUndefined; // 是否隐藏非维度组行为表现
  hiddenDimensionEvaluate = EnumBoolOption.EnumBoolOptionUndefined; // 是否隐藏非维度组评价
  topParamShowAll = EnumBoolOption.EnumBoolOptionUndefined; // 顶部登记信息是否展示全部字段
  englishAssessmentShowType = 0; // 英语报告部分展示类型 int
  hiddenSubmitDuration = EnumBoolOption.EnumBoolOptionUndefined; // 是否隐藏面试总时长
  showDimensionGroupAiComment = EnumBoolOption.EnumBoolOptionUndefined; // 是否展示维度组的组内总评价
}
// 面试配置包配置
export class StructConfigGroup extends Model {
  configGroupId = 0; // IntId 配置id
  name = ""; // 配置名称
  reportVersion = EnumReportVersion.EnumReportVersionDefault; // 报告版本
  showType = EnumShowType.EnumShowTypeDimension; // 维度展示方式
  scoreType = EnumScoreType.EnumScoreTypeQuestion; // 计分方式
  suggestType = EnumSuggestType.EnumSuggestTypeClose; // AI评价类型
  showReferenceAnswer = EnumBoolOption.EnumBoolOptionUndefined; // 是否展示参考答案
  needReadingGuidelines = EnumBoolOption.EnumBoolOptionUndefined; // 是否需要阅读指引
  reportShowConfig = new StructReportShowConfig(); // 报告页展示配置

  static get() {
    return request.post("/aiExam/company/configGroupList").then(resp => {
      return resp.data.data.list;
    });
  }
}
// 阅读指引维度组类型
export const EnumReadingGuidelinesType = {
  EnumReadingGuidelinesTypeCommon: 1, // 通用素质
  EnumReadingGuidelinesTypeMatch: 2, // 岗位匹配度
  EnumReadingGuidelinesTypeJob: 3, // 职业规划
  EnumReadingGuidelinesTypeCustom: 4 // 进阶能力
};
//维度组配置
export class StructDimensionGroupConfig extends Model {
  groupName = ""; // 维度组名
  showChart = EnumBoolOption.EnumBoolOptionUndefined; // 是否显示图表
  showComport = EnumBoolOption.EnumBoolOptionUndefined; // 是否显示行为表现
  showEvaluate = EnumBoolOption.EnumBoolOptionUndefined; // 是否显示评价
  readingGuidelinesType =
    EnumReadingGuidelinesType.EnumReadingGuidelinesTypeCommon; // 阅读指引维度组类型
  readingGuidelinesMessage = ""; // 阅读指引进阶能力类型结果说明
  iconUrl = ""; // 图标链接
  dimensionKeyList = [""]; // 维度键列表 []string

  static get() {
    return request.post("/aiExam/company/iconUrlList").then(resp => {
      return resp.data.data.list;
    });
  }
}
